import { render } from "./OrgSelectionPage.vue?vue&type=template&id=66208fce&scoped=true"
import script from "./OrgSelectionPage.vue?vue&type=script&lang=js"
export * from "./OrgSelectionPage.vue?vue&type=script&lang=js"

import "./OrgSelectionPage.vue?vue&type=style&index=0&id=66208fce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66208fce"]])

export default __exports__